import type { MigrationStrategies } from "./_types/migration-strategies";

export const INVESTIGATION_ACTIVITY_MIGRATION_STRATEGIES: MigrationStrategies =
  {
    1: (oldDoc) => oldDoc,
    // Delete them all.
    2: (_) => null,
    3: (oldDoc) => oldDoc,
    4: (oldDoc) => oldDoc,
    5: (_) => null,
    6: (oldDoc) => oldDoc,
    7: (_) => null,
    8: (oldDoc) => oldDoc,
    9: (oldDoc) => oldDoc,
  };
